import type { AdminQueryPort } from "../../contracts/admin-query-port";
import type { AdminAuthSession } from "../../shared/auth/admin-auth-session";
import { createFixtureAdminQueryAdapter } from "../../shared/query/fixture-admin-query-adapter";
import { createHttpAdminQueryAdapter } from "../../shared/query/http-admin-query-adapter";
import type { AdminDashboardRuntimeConfig } from "./admin-dashboard-runtime-config";

export type CreateAdminQueryClientFetchFn = typeof fetch;

export function createAdminQueryClient(
  config: AdminDashboardRuntimeConfig,
  session?: AdminAuthSession,
  fetchFn?: CreateAdminQueryClientFetchFn,
): AdminQueryPort {
  if (config.authMode === "fixture") {
    return createFixtureAdminQueryAdapter();
  }

  return createHttpAdminQueryAdapter({
    apiBaseUrl: config.apiBaseUrl,
    getAccessToken: session?.getAccessToken,
    fetchFn,
  });
}
